module.exports = __webpack_public_path__ + "img/SafariBrowser.90692c04.svg";